import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import {
  editWebhookEndpoint,
  EditWebhookEndpointPayload,
} from 'api/admin/businesses/editWebhookEndpoint';

export const useEditWebhookEndpoint = () => {
  return useMutation<unknown, AxiosError<{ error: string }>, EditWebhookEndpointPayload>({
    mutationFn: async ({ configId, businessId, webhookEndpoint }) => {
      return editWebhookEndpoint({
        configId,
        businessId,
        webhookEndpoint,
      });
    },
    onSuccess: async () => {
      toaster('Webhook endpoint has been updated', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(error?.response?.data?.error ?? 'An error occurred while updating webhook endpoint', {
        icon: '❌',
      });
      return error;
    },
  });
};
